import { formatBRL } from '@/lib/format';
import type { Receipt } from '@/lib/types';

interface TransferBadgeProps {
  receipt: Pick<Receipt, 'transferStatus' | 'transferAmount'>;
  /** Mostra o valor puxado junto do "feito". */
  withAmount?: boolean;
  /** "Repasse feito" em vez de "Feito" — onde não há coluna dizendo que é repasse. */
  long?: boolean;
}

/** Selo da situação do repasse — o mesmo em toda tela que lista comprovantes. */
export function TransferBadge({ receipt, withAmount = false, long = false }: TransferBadgeProps) {
  if (receipt.transferStatus === 'DONE') {
    const label = long ? 'Repasse feito' : 'Feito';
    return (
      <span className="chip chip-positive">
        {withAmount ? `${label} · ${formatBRL(receipt.transferAmount)}` : label}
      </span>
    );
  }
  if (receipt.transferStatus === 'PENDING') {
    return <span className="chip chip-warning">{long ? 'Repasse pendente' : 'Pendente'}</span>;
  }
  return <span className="chip">Sem repasse</span>;
}
